import isValidProp from '@emotion/is-prop-valid';
export var shouldForwardProp = function shouldForwardProp() {
  var allowedProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (prop) {
    if (allowedProps.includes(prop)) {
      return true;
    }
    return isValidProp(String(prop));
  };
};
export var shouldNotForwardProp = function shouldNotForwardProp() {
  var forbiddenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (prop) {
    return !forbiddenProps.includes(prop);
  };
};
//# sourceMappingURL=shouldForwardProp.js.map